// Centralized Google Maps loader configuration
// This ensures the loader is only initialized once with consistent options

// Use environment variable for production, fallback API key for development
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyAH6ReFOYbWQghu-CMNXQUhqBuA44YF_C4";

// Only initialize maps if we have a valid API key
export const googleMapsLoaderOptions = GOOGLE_MAPS_API_KEY ? {
  id: "google-maps-script",
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  version: "weekly",
  libraries: [], // Empty array - we only need the base Maps JavaScript API for markers
  language: "nl",
  region: "NL",
} : null;
